import axios from "axios"
import cookie from "js-cookie"

const logOut = (error) => {
    if (error.response?.status === 401) {
      cookie.remove('auth');
      // window.location.replace('/login');
    }
  }
  
  export async function postCall(endpoint, data, headers) {
    const bearerToken = cookie.get('auth');
  
    return axios({
      method: 'POST',
      url: endpoint,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
        ...headers,
      },
      data,
    })
      .then((response) => response)
      .catch((error) => {
        logOut(error)
        return error.response;
      });
  }
  
  export async function getCall(endpoint, headers) {
    const bearerToken = cookie.get('auth');
    return axios({
      method: 'GET',
      url: endpoint,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
        ...headers,
      },
    })
      .then((response) => response)
      .catch((error) => {
        logOut(error)
        return error.response;
      });
  }
  
  export async function patchCall(endpoint, data, headers) {
    const bearerToken = cookie.get('auth');
    return axios({
      method: 'PATCH',
      url: endpoint,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
        ...headers,
      },
      data,
    })
      .then((response) => response)
      .catch((error) => {
        logOut(error)
        return error.response
      });
  }
  
  export async function putCall(endpoint, data, headers) {
    const bearerToken = cookie.get('auth');
    return axios({
      method: 'PUT',
      url: endpoint,
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${bearerToken}`,
      },
      data,
    })
      .then((response) => response)
      .catch((error) => {
        logOut(error)
        return error.response;
      });
  }